import { render, staticRenderFns } from "./WakafKumpulan.vue?vue&type=template&id=042c7b42&scoped=true"
import script from "./WakafKumpulan.vue?vue&type=script&lang=js"
export * from "./WakafKumpulan.vue?vue&type=script&lang=js"
import style0 from "./WakafKumpulan.vue?vue&type=style&index=0&id=042c7b42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042c7b42",
  null
  
)

export default component.exports